import { useAuth } from '../auth/useAuth';
import { FEATURE_REGISTRY } from '../features/featureRegistry';

export function useNavPermissions() {
  const { user, isAdmin, hasFeature } = useAuth();

  const hasWorkFeatures = FEATURE_REGISTRY.some(
    (f) => f.area === 'work' && hasFeature(f.id)
  );
  const hasLifeFeatures = FEATURE_REGISTRY.some(
    (f) => f.area === 'life' && hasFeature(f.id)
  );

  return { isLoggedIn: !!user, hasWorkFeatures, hasLifeFeatures, isAdmin };
}
